(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('fileMapper', fileMapper);

	function fileMapper(_, utility, uriUtility, assetCommonConfig) {

		function computeImageDimensions(file) {
			if (!file.metadata)
				return null;

			var image = file.metadata.image;
			var width = image && image.width;
			var height = image && image.height;
			if (!(width > 0 && height > 0))
				return null;

			return {
				width: width,
				height: height
			};
		}

		function mapFile(source, assetId, revisionId) {
			if (!source)
				return undefined;

			if (_.isArray(source)) {
				return source.map(function (x) {
					return mapFile(x, assetId, revisionId);
				});
			}

			var file = {
				id: source.id,
				name: source.name,
				byteCount: source.byteCount,
				lastModified: source.lastModified,
				mediaType: source.mediaType,
				metadata: _.omit(source.metadata, 'title', 'authors', 'description', 'headline', 'copyright', 'license', 'workflow', 'contact', 'tags', 'categories', 'location')
			};

			utility.defineLazyProperty(file,
				'dimensions', function () {
					return computeImageDimensions(this);
				});

			utility.defineLazyProperty(file,
				'primaryMetadata', function () {
					if (!this.metadata)
						return null;

					var filteredMetadata = _.clone(this.metadata);
					delete filteredMetadata.lastModified; // moved to file
					delete filteredMetadata.updated; // not interesting to users
					return filteredMetadata;
				});

			utility.defineLazyProperty(file,
				'url', function () {
					if (!assetId)
						throw new Error('File must be attached to an asset.');

					return uriUtility.fromPattern(assetCommonConfig.assetServiceBaseUri + 'assets/{assetId}/files/{fileId}/content', { assetId: assetId, fileId: this.id, rev: revisionId });
				});

			return file;
		}

		return {
			map: mapFile
		};
	}
	fileMapper.$inject = ['_', 'utility', 'uriUtility', 'assetCommonConfig'];
})();
